export const TRACKING_SOURCES = {
  MERCH_CARD: 'merch-card',
  CALCULATOR: 'calculator',
  SUITE_CARD: 'suite-card',
  FREE_CARD: 'free-card',
  SUITE_CALCULATOR: 'suite-calculator',
  CMS_CARD: 'cms-card',
  MIGRATE_YOUR_SITE: 'migrate-your-site',
  CREATE_A_BUNDLE: 'create-a-bundle',
  BUNDLE_CARD: 'bundle-card',
  PRODUCT_CARD: 'product-card',
  ADD_ON_CARD: 'add-on-card',
  HUBSPOT_CREDITS_CARD: 'hubspot-credits-card',
  SMALL_HUBSPOT_CREDITS_CARD: 'SMALL-hubspot-credits-card',
  MEDIUM_HUBSPOT_CREDITS_CARD: 'MEDIUM-hubspot-credits-card',
  LARGE_HUBSPOT_CREDITS_CARD: 'LARGE-hubspot-credits-card',
  HUBSPOT_CREDITS_CARDS_SECTION: 'hubspot-credits-cards-section',
  PAID_VS_FREE_USERS_MODAL: 'paid-vs-free-users-modal',
  PRODUCT_PAGE_HEADER: 'product-page-header',
  APP: 'pricing-pages',
  WHY_GO_HUBSPOT_CARD: 'why-go-hubspot-card',
  INTERSTITIAL: 'interstitial',
  INTERSTITIAL_HEADER: 'interstitial-header',
  PRODUCT_PAGE_FEATURE_TABLE_HEADER: 'product-page-feature-table-header',
  SUITE_FEATURE_TABLE_HEADER: 'suite-feature-table-header',
  BUNDLE_FEATURE_TABLE_HEADER: 'bundle-feature-table-header',
  SMART_CRM_FEATURE_TABLE_HEADER: 'smart-crm-feature-table-header',
  CLEARBIT_BANNER: 'clearbit-banner',
  ONBOARDING_CARD: 'onboarding-card',
  MARKETING_PLUS_CARD: 'marketing-plus-card',
  FAQ: 'faq',
  SSM0003_VAR_B_STARTER_CARD: 'ssm0003-var-b-starter-card',
  STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD: 'starter-customer-platform-upsell-merch-card',
  MARKETING_HUB_ENTERPRISE_PRICE_CHANGE_BANNER: 'marketing-hub-enterprise-price-change-banner',
  MARKETING_PLUS_PAGE_FEATURE_TABLE: 'marketing-plus-page-feature-table',
  WINTER_NEW_CUSTOMER_STARTER_2024_BANNER: 'winter-new-customer-starter-2024-banner',
  CONTACT_SALES_PAGE: 'contact-sales-page',
  IN_APP: 'in-app',
  PUBLIC: 'public',
  BUNDLE: 'bundle',
  CMS_MIDDLE: 'cms-middle',
  CRM_MIDDLE: 'crm-middle',
  MARKETING_PLUS_MIDDLE: 'marketingplus-middle',
  MARKETING_PLUS_FOOTER: 'marketingplus-footer',
  MARKETING_MIDDLE: 'marketing-middle',
  SALES_MIDDLE: 'sales-middle',
  SERVICE_MIDDLE: 'service-middle',
  OPERATIONS_MIDDLE: 'operations-middle',
  CMS_MIDDLE_FOOTER: 'cms-footer',
  CRM_FOOTER: 'crm-footer',
  MARKETING_FOOTER: 'marketing-footer',
  SALES_FOOTER: 'sales-footer',
  SERVICE_FOOTER: 'service-footer',
  OPERATIONS_FOOTER: 'operations-footer',
  CMS_FOOTER: 'cms-footer',
  COMMERCE_MIDDLE: 'commerce-middle',
  COMMERCE_FOOTER: 'commerce-footer',
  PRODUCT_PAGE: 'product-page',
  MOBILE_PRODUCT_PAGE: 'mobile-product-page',
  CRM_SUITE_MIDDLE: 'crmsuite-middle',
  CRM_SUITE_FOOTER: 'crmsuite-footer',
  SMART_CRM_MIDDLE: 'smart-crm-middle',
  SMART_CRM_FOOTER: 'smart-crm-footer',
  SMART_CRM_CARD: 'smart-crm-card',
  HUBSPOT_CREDITS_VALUE_PROPOSITIONS: 'hubspot-credits-value-propositions',
  CREDITS_CALLOUT: 'CREDITS_CALLOUT',
  ROI_CALLOUT: 'ROI_CALLOUT',
  USE_CASES_TIER_COMPARISON: 'USE_CASES_TIER_COMPARISON',
  HSOC_PLAN_CONFIGURATION_CARD: 'hsoc-plan-configuration-card',
  HSOC_ADD_SEATS_MODAL: 'hsoc-add-seats-modal',
  HSOC_ADD_CREDITS_MODAL: 'hsoc-add-credits-modal',
  HSOC_ADD_CREDITS_FIRST_TIME_MODAL: 'hsoc-add-credits-first-time-modal',
  HSOC_MERCH_CARDS_SECTION: 'hsoc-merch-cards-section',
  USE_CASES_SECTION: 'use-cases-section',
  HSOC_ADD_ONS: 'hsoc-add-ons',
  CUSTOMIZE_YOUR_PLAN: 'customize-your-plan',
  CREDITS_EXPLAINER: 'credits-explainer',
  SEATS_EXPLAINER: 'seats-explainer',
  AEO_STANDALONE_PROMO_CARD: 'aeo-standalone-promo-card',
  COMPETITIVE_ANALYSIS_CARD: 'competitive-analysis-card'
};
// individual exports for backwards compatibility
export const {
  MERCH_CARD,
  PRODUCT_CARD,
  CALCULATOR,
  SUITE_CARD,
  FREE_CARD,
  SUITE_CALCULATOR,
  CMS_CARD,
  MIGRATE_YOUR_SITE,
  CREATE_A_BUNDLE,
  BUNDLE_CARD,
  ADD_ON_CARD,
  HUBSPOT_CREDITS_CARD,
  SMALL_HUBSPOT_CREDITS_CARD,
  MEDIUM_HUBSPOT_CREDITS_CARD,
  LARGE_HUBSPOT_CREDITS_CARD,
  HUBSPOT_CREDITS_CARDS_SECTION,
  PAID_VS_FREE_USERS_MODAL,
  PRODUCT_PAGE_HEADER,
  APP,
  WHY_GO_HUBSPOT_CARD,
  INTERSTITIAL,
  SUITE_FEATURE_TABLE_HEADER,
  PRODUCT_PAGE_FEATURE_TABLE_HEADER,
  CLEARBIT_BANNER,
  ONBOARDING_CARD,
  BUNDLE_FEATURE_TABLE_HEADER,
  SMART_CRM_FEATURE_TABLE_HEADER,
  MARKETING_PLUS_CARD,
  SSM0003_VAR_B_STARTER_CARD,
  STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD,
  MARKETING_PLUS_PAGE_FEATURE_TABLE,
  WINTER_NEW_CUSTOMER_STARTER_2024_BANNER,
  CONTACT_SALES_PAGE,
  SMART_CRM_CARD,
  SMART_CRM_MIDDLE,
  SMART_CRM_FOOTER,
  HUBSPOT_CREDITS_VALUE_PROPOSITIONS,
  CREDITS_CALLOUT,
  USE_CASES_TIER_COMPARISON,
  ROI_CALLOUT,
  USE_CASES_SECTION,
  HSOC_PLAN_CONFIGURATION_CARD,
  HSOC_ADD_SEATS_MODAL,
  HSOC_ADD_CREDITS_MODAL,
  HSOC_ADD_CREDITS_FIRST_TIME_MODAL,
  HSOC_MERCH_CARDS_SECTION,
  CUSTOMIZE_YOUR_PLAN,
  CREDITS_EXPLAINER,
  SEATS_EXPLAINER,
  HSOC_ADD_ONS,
  AEO_STANDALONE_PROMO_CARD,
  COMPETITIVE_ANALYSIS_CARD
} = TRACKING_SOURCES;